{
  "source": "loadtest/results/uc7-eval/*.json (raw probe output, committed; composed into loadtest/results/UC7-EVALUATION.md)",
  "percentileMethod": "nearest-rank (inclusive), recomputed from the committed per-sample arrays",
  "latencyExcludes": "the customer’s own Apigee hop; measured client-side from a runner INSIDE the region under test",
  "abba": {
    "use1": {
      "regionId": "use1",
      "awsRegion": "us-east-1",
      "host": "ip-10-61-0-60.ec2.internal",
      "cpus": 8,
      "offeredRps": 100,
      "blockSec": 60,
      "repeats": 3,
      "warmSec": 180,
      "samplesTotal": 72019,
      "blocksTotal": 12,
      "arms": {
        "v4": {
          "blocks": 6,
          "n": 36009,
          "min": 23.02,
          "p50": 30.91,
          "p90": 35.53,
          "p99": 40.9,
          "max": 1378.67,
          "blockP50s": [
            30.73,
            30.78,
            30.91,
            31.17,
            30.68,
            31.21
          ],
          "errorRate": 0,
          "appThrottled": 0,
          "gatewayThrottled": 0
        },
        "v7": {
          "blocks": 6,
          "n": 36010,
          "min": 13.32,
          "p50": 20.52,
          "p90": 25.07,
          "p99": 30.7,
          "max": 176.75,
          "blockP50s": [
            20.61,
            20.78,
            20.54,
            20.68,
            20.36,
            20.14
          ],
          "errorRate": 0,
          "appThrottled": 0,
          "gatewayThrottled": 0
        }
      },
      "pairs": [
        {
          "repeat": 1,
          "v4p50": 30.76,
          "v7p50": 20.7,
          "deltaP50": -10.06,
          "v4p99": 40.59,
          "v7p99": 30.75,
          "deltaP99": -9.84
        },
        {
          "repeat": 2,
          "v4p50": 31.04,
          "v7p50": 20.61,
          "deltaP50": -10.43,
          "v4p99": 40.7,
          "v7p99": 30.69,
          "deltaP99": -10.01
        },
        {
          "repeat": 3,
          "v4p50": 30.95,
          "v7p50": 20.25,
          "deltaP50": -10.69,
          "v4p99": 41.39,
          "v7p99": 30.66,
          "deltaP99": -10.73
        }
      ],
      "v7FasterInEveryBlock": true,
      "provenance": {
        "v4Engines": [
          "aurora-dsql"
        ],
        "v7Engines": [
          "aurora-global-postgresql"
        ],
        "v7Roles": [
          "primary"
        ],
        "v7ReadEndpoints": [
          "usps-demo-rules-g-use1.cluster-c7wko20kw4rh.us-east-1.rds.amazonaws.com"
        ]
      },
      "cold": {
        "v4": [
          153,
          44,
          43,
          48,
          52
        ],
        "v7": [
          30,
          27,
          36,
          32,
          33
        ]
      }
    },
    "usw2": {
      "regionId": "usw2",
      "awsRegion": "us-west-2",
      "host": "ip-10-60-0-216.us-west-2.compute.internal",
      "cpus": 8,
      "offeredRps": 100,
      "blockSec": 60,
      "repeats": 3,
      "warmSec": 180,
      "samplesTotal": 72019,
      "blocksTotal": 12,
      "arms": {
        "v4": {
          "blocks": 6,
          "n": 36011,
          "min": 20.36,
          "p50": 27.34,
          "p90": 31.2,
          "p99": 37.15,
          "max": 1153.94,
          "blockP50s": [
            27.77,
            26.84,
            27.34,
            27.24,
            27.77,
            27.03
          ],
          "errorRate": 0,
          "appThrottled": 0,
          "gatewayThrottled": 0
        },
        "v7": {
          "blocks": 6,
          "n": 36008,
          "min": 12.88,
          "p50": 18.58,
          "p90": 22.18,
          "p99": 28.26,
          "max": 240.85,
          "blockP50s": [
            18.86,
            18.22,
            18.06,
            18.8,
            18.46,
            19.08
          ],
          "errorRate": 0,
          "appThrottled": 0,
          "gatewayThrottled": 0
        }
      },
      "pairs": [
        {
          "repeat": 1,
          "v4p50": 27.31,
          "v7p50": 18.54,
          "deltaP50": -8.76,
          "v4p99": 37.27,
          "v7p99": 29.14,
          "deltaP99": -8.13
        },
        {
          "repeat": 2,
          "v4p50": 27.29,
          "v7p50": 18.43,
          "deltaP50": -8.86,
          "v4p99": 36,
          "v7p99": 26.13,
          "deltaP99": -9.88
        },
        {
          "repeat": 3,
          "v4p50": 27.4,
          "v7p50": 18.77,
          "deltaP50": -8.63,
          "v4p99": 36.59,
          "v7p99": 28.21,
          "deltaP99": -8.37
        }
      ],
      "v7FasterInEveryBlock": true,
      "provenance": {
        "v4Engines": [
          "aurora-dsql"
        ],
        "v7Engines": [
          "aurora-global-postgresql"
        ],
        "v7Roles": [
          "secondary"
        ],
        "v7ReadEndpoints": [
          "usps-demo-rules-g-usw2.cluster-ro-cog4o5b1kwqr.us-west-2.rds.amazonaws.com"
        ]
      },
      "cold": {
        "v4": [
          149,
          35,
          47,
          33,
          35
        ],
        "v7": [
          27,
          25,
          36,
          28,
          25
        ]
      }
    }
  },
  "events": {
    "patch": {
      "t0Iso": "2026-08-05T08:33:23Z",
      "triggerReturnedMs": 4131,
      "use1": {
        "regionId": "use1",
        "awsRegion": "us-east-1",
        "label": "patch",
        "intervalMs": 250,
        "samples": 7178,
        "ok": 7178,
        "failed": 0,
        "p50": 24,
        "p99": 37,
        "appThrottled": 0,
        "gatewayThrottled": 0,
        "byErrorCode": {},
        "outageMs": 0,
        "windows": [],
        "stillFailing": false,
        "provenance": {
          "engines": [
            "aurora-global-postgresql"
          ],
          "readEndpoints": [
            "usps-demo-rules-g-use1.cluster-c7wko20kw4rh.us-east-1.rds.amazonaws.com"
          ],
          "globalRoles": [
            "primary"
          ]
        },
        "failureSpacingMs": null
      },
      "usw2": {
        "regionId": "usw2",
        "awsRegion": "us-west-2",
        "label": "patch",
        "intervalMs": 250,
        "samples": 7162,
        "ok": 7095,
        "failed": 67,
        "p50": 24,
        "p99": 36,
        "appThrottled": 0,
        "gatewayThrottled": 0,
        "byErrorCode": {
          "GLOBAL_DB_UNAVAILABLE": 66,
          "INTERNAL": 1
        },
        "outageMs": 16525,
        "windows": [
          {
            "startsAtT0Ms": 106067,
            "observedMs": 16525,
            "outerBoundMs": 21656,
            "failures": 67,
            "codes": {
              "503:GLOBAL_DB_UNAVAILABLE": 66,
              "500:INTERNAL": 1
            },
            "stillFailing": false
          }
        ],
        "stillFailing": false,
        "provenance": {
          "engines": [
            "aurora-global-postgresql"
          ],
          "readEndpoints": [
            "usps-demo-rules-g-usw2.cluster-ro-cog4o5b1kwqr.us-west-2.rds.amazonaws.com"
          ],
          "globalRoles": [
            "secondary"
          ]
        },
        "failureSpacingMs": 250
      },
      "bothDarkMs": 0
    },
    "switchover": {
      "t0Iso": "2026-08-05T09:06:00Z",
      "triggerReturnedMs": 2837,
      "use1": {
        "regionId": "use1",
        "awsRegion": "us-east-1",
        "label": "switchover",
        "intervalMs": 250,
        "samples": 2818,
        "ok": 2593,
        "failed": 225,
        "p50": 25,
        "p99": 37,
        "appThrottled": 0,
        "gatewayThrottled": 0,
        "byErrorCode": {
          "GLOBAL_DB_UNAVAILABLE": 224,
          "INTERNAL": 1
        },
        "outageMs": 66939,
        "windows": [
          {
            "startsAtT0Ms": 33886,
            "observedMs": 66939,
            "outerBoundMs": 70954,
            "failures": 225,
            "codes": {
              "503:GLOBAL_DB_UNAVAILABLE": 224,
              "500:INTERNAL": 1
            },
            "stillFailing": false
          }
        ],
        "stillFailing": false,
        "provenance": {
          "engines": [
            "aurora-global-postgresql"
          ],
          "readEndpoints": [
            "usps-demo-rules-g-use1.cluster-c7wko20kw4rh.us-east-1.rds.amazonaws.com"
          ],
          "globalRoles": [
            "primary"
          ]
        },
        "failureSpacingMs": 251
      },
      "usw2": {
        "regionId": "usw2",
        "awsRegion": "us-west-2",
        "label": "switchover",
        "intervalMs": 250,
        "samples": 2874,
        "ok": 2835,
        "failed": 39,
        "p50": 24,
        "p99": 35,
        "appThrottled": 0,
        "gatewayThrottled": 0,
        "byErrorCode": {
          "GLOBAL_DB_UNAVAILABLE": 37,
          "INTERNAL": 2
        },
        "outageMs": 9950,
        "windows": [
          {
            "startsAtT0Ms": 32893,
            "observedMs": 9950,
            "outerBoundMs": 10452,
            "failures": 39,
            "codes": {
              "503:GLOBAL_DB_UNAVAILABLE": 37,
              "500:INTERNAL": 2
            },
            "stillFailing": false
          }
        ],
        "stillFailing": false,
        "provenance": {
          "engines": [
            "aurora-global-postgresql"
          ],
          "readEndpoints": [
            "usps-demo-rules-g-usw2.cluster-ro-cog4o5b1kwqr.us-west-2.rds.amazonaws.com"
          ],
          "globalRoles": [
            "secondary"
          ]
        },
        "failureSpacingMs": 251
      },
      "bothDarkMs": 8957
    },
    "failover": {
      "t0Iso": "2026-08-05T09:29:22Z",
      "triggerReturnedMs": 1781,
      "use1": {
        "regionId": "use1",
        "awsRegion": "us-east-1",
        "label": "failover",
        "intervalMs": 250,
        "samples": 2605,
        "ok": 2489,
        "failed": 116,
        "p50": 24,
        "p99": 36,
        "appThrottled": 0,
        "gatewayThrottled": 0,
        "byErrorCode": {
          "GLOBAL_DB_UNAVAILABLE": 115,
          "INTERNAL": 1
        },
        "outageMs": 36421,
        "windows": [
          {
            "startsAtT0Ms": 16505,
            "observedMs": 36421,
            "outerBoundMs": 36921,
            "failures": 116,
            "codes": {
              "503:GLOBAL_DB_UNAVAILABLE": 115,
              "500:INTERNAL": 1
            },
            "stillFailing": false
          }
        ],
        "stillFailing": false,
        "provenance": {
          "engines": [
            "aurora-global-postgresql"
          ],
          "readEndpoints": [
            "usps-demo-rules-g-use1.cluster-c7wko20kw4rh.us-east-1.rds.amazonaws.com"
          ],
          "globalRoles": [
            "primary"
          ]
        },
        "failureSpacingMs": 251
      },
      "usw2": {
        "regionId": "usw2",
        "awsRegion": "us-west-2",
        "label": "failover",
        "intervalMs": 250,
        "samples": 462,
        "ok": 347,
        "failed": 115,
        "p50": 25,
        "p99": 36,
        "appThrottled": 0,
        "gatewayThrottled": 0,
        "byErrorCode": {
          "GLOBAL_DB_UNAVAILABLE": 115
        },
        "outageMs": 569136,
        "windows": [
          {
            "startsAtT0Ms": 12575,
            "observedMs": 569136,
            "outerBoundMs": null,
            "failures": 115,
            "codes": {
              "503:GLOBAL_DB_UNAVAILABLE": 115
            },
            "stillFailing": true
          }
        ],
        "stillFailing": true,
        "provenance": {
          "engines": [
            "aurora-global-postgresql"
          ],
          "readEndpoints": [
            "usps-demo-rules-g-usw2.cluster-ro-cog4o5b1kwqr.us-west-2.rds.amazonaws.com"
          ],
          "globalRoles": [
            "secondary"
          ]
        },
        "failureSpacingMs": 5030
      },
      "bothDarkMs": 36421
    }
  },
  "ladder": {
    "use1": {
      "regionId": "use1",
      "awsRegion": "us-east-1",
      "rungs": [
        {
          "offeredRps": 25,
          "attemptedRps": 25.01,
          "succeededRps": 25.01,
          "p50": 20.92,
          "p99": 31.25,
          "errorRate": 0,
          "appThrottled": 0,
          "gatewayThrottled": 0,
          "clientCapHits": 0,
          "peakClientConcurrency": 2
        },
        {
          "offeredRps": 100,
          "attemptedRps": 99.98,
          "succeededRps": 99.98,
          "p50": 20.78,
          "p99": 31.33,
          "errorRate": 0,
          "appThrottled": 0,
          "gatewayThrottled": 0,
          "clientCapHits": 0,
          "peakClientConcurrency": 5
        },
        {
          "offeredRps": 400,
          "attemptedRps": 399.89,
          "succeededRps": 399.89,
          "p50": 20.25,
          "p99": 33.19,
          "errorRate": 0,
          "appThrottled": 0,
          "gatewayThrottled": 0,
          "clientCapHits": 0,
          "peakClientConcurrency": 40
        },
        {
          "offeredRps": 800,
          "attemptedRps": 799.72,
          "succeededRps": 799.72,
          "p50": 20.21,
          "p99": 32.39,
          "errorRate": 0,
          "appThrottled": 0,
          "gatewayThrottled": 0,
          "clientCapHits": 0,
          "peakClientConcurrency": 44
        },
        {
          "offeredRps": 1600,
          "attemptedRps": 264.41,
          "succeededRps": 190.78,
          "p50": 3995.06,
          "p99": 27138.85,
          "errorRate": 0.278455,
          "appThrottled": 0,
          "gatewayThrottled": 0,
          "clientCapHits": 15079,
          "peakClientConcurrency": 4000
        },
        {
          "offeredRps": 3200,
          "attemptedRps": 262.42,
          "succeededRps": 142.31,
          "p50": 4007.6,
          "p99": 25337.5,
          "errorRate": 0.457678,
          "appThrottled": 0,
          "gatewayThrottled": 0,
          "clientCapHits": 16285,
          "peakClientConcurrency": 4000
        }
      ],
      "highestCleanRps": 800
    },
    "usw2": {
      "regionId": "usw2",
      "awsRegion": "us-west-2",
      "rungs": [
        {
          "offeredRps": 25,
          "attemptedRps": 25.01,
          "succeededRps": 25.01,
          "p50": 19.33,
          "p99": 27.97,
          "errorRate": 0,
          "appThrottled": 0,
          "gatewayThrottled": 0,
          "clientCapHits": 0,
          "peakClientConcurrency": 2
        },
        {
          "offeredRps": 100,
          "attemptedRps": 99.99,
          "succeededRps": 99.99,
          "p50": 19.27,
          "p99": 27.72,
          "errorRate": 0,
          "appThrottled": 0,
          "gatewayThrottled": 0,
          "clientCapHits": 0,
          "peakClientConcurrency": 4
        },
        {
          "offeredRps": 400,
          "attemptedRps": 399.9,
          "succeededRps": 399.9,
          "p50": 19.05,
          "p99": 62.11,
          "errorRate": 0,
          "appThrottled": 0,
          "gatewayThrottled": 0,
          "clientCapHits": 0,
          "peakClientConcurrency": 159
        },
        {
          "offeredRps": 800,
          "attemptedRps": 799.77,
          "succeededRps": 799.77,
          "p50": 18.68,
          "p99": 31.67,
          "errorRate": 0,
          "appThrottled": 0,
          "gatewayThrottled": 0,
          "clientCapHits": 0,
          "peakClientConcurrency": 39
        },
        {
          "offeredRps": 1600,
          "attemptedRps": 254.2,
          "succeededRps": 167.5,
          "p50": 3163.59,
          "p99": 26653.75,
          "errorRate": 0.34105,
          "appThrottled": 0,
          "gatewayThrottled": 0,
          "clientCapHits": 15537,
          "peakClientConcurrency": 4000
        },
        {
          "offeredRps": 3200,
          "attemptedRps": 254.6,
          "succeededRps": 99.28,
          "p50": 2001.62,
          "p99": 19920.63,
          "errorRate": 0.610058,
          "appThrottled": 0,
          "gatewayThrottled": 0,
          "clientCapHits": 15149,
          "peakClientConcurrency": 4000
        }
      ],
      "highestCleanRps": 800
    },
    "peakDatabaseConnections": {
      "use1": 835,
      "usw2": 834
    }
  },
  "rpo": {
    "switchover": {
      "acked": 253,
      "expected": 253,
      "missing": 0
    },
    "failover": {
      "acked": 562,
      "lo": 1,
      "hi": 562,
      "holes": 0
    }
  },
  "integrityAfterFailover": {
    "rules": 12,
    "customers": 4,
    "serviceTypeCodes": 8,
    "weightBands": 3,
    "foreignKeys": 6,
    "checkConstraints": 16
  },
  "writeArms": [
    {
      "stream": "A-fwd-off",
      "awsRegion": "us-west-2",
      "observedConsistencyMode": "off",
      "attempted": 3,
      "succeeded": 0,
      "p50": 2,
      "refusalCode": "25006"
    },
    {
      "stream": "B-fwd-session",
      "awsRegion": "us-west-2",
      "observedConsistencyMode": null,
      "attempted": 40,
      "succeeded": 40,
      "p50": 117,
      "refusalCode": null
    },
    {
      "stream": "C-fwd-global",
      "awsRegion": "us-west-2",
      "observedConsistencyMode": "global",
      "attempted": 40,
      "succeeded": 40,
      "p50": 1437,
      "refusalCode": null
    },
    {
      "stream": "D-primary-direct",
      "awsRegion": "us-east-1",
      "observedConsistencyMode": null,
      "attempted": 40,
      "succeeded": 40,
      "p50": 3,
      "refusalCode": null
    }
  ]
}
